import { View } from 'react-native';

type Props = {
  url: string;
};

// `#toolbar=0&navpanes=0` hides the browser PDF viewer's gray toolbar/side
// panel, leaving just the scrollable document. The fragment is appended after
// any presigned-URL query string, so it doesn't affect the request.
const hideViewerChrome = (url: string) => `${url}#toolbar=0&navpanes=0`;

// Web: render the PDF inline via an iframe (S3 presigned URL).
export const PdfFrame = ({ url }: Props) => (
  <View style={{ flex: 1, width: '100%', height: '100%' }}>
    <iframe
      src={hideViewerChrome(url)}
      title="document"
      style={{ width: '100%', height: '100%', border: 'none' }}
    />
  </View>
);
